/* Shop the Look × OMES — grid filters, saved looks, look detail (colours, sizes, swaps, add-to-cart), mobile sheets / peek / swipe.
   Vanilla JS, no dependencies. Loaded with `defer` by sections/stl-looks-grid.liquid and sections/stl-look-detail.liquid.
   Behaviour ported from docs/handoff-shop-the-look/reference/shop-the-look.html (desktop) and shop-the-look-mobile.html (≤ 760px).
   Specs: docs/handoff-shop-the-look/screens/looks-grid.md, look-detail.md and their .mobile.md.
   Changes from the handoff, for this theme:
   - the sticky strip docks under the theme's sticky header group and the fixed cart bar sits above its
     mobile toolbar (.mbtlwraper), both measured, as assets/aide-retours.js does;
   - a piece sold in several colours asks for its colour too (the handoff knew only sizes), and is priced
     at the chosen variant;
   - « Ajouter le look au panier » renders the theme's cart drawer and puts OMES Bundles' codes on the
     cart, as assets/omes-product.js does after a set or a multipack. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = (s) => String(s ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const MOBILE = matchMedia('(max-width: 760px)');
  const isMobile = () => MOBILE.matches;

  /* ---------- theme chrome: sticky header above, fixed toolbar below ---------- */
  function placeChrome(root) {
    let head = 0;
    $$('.shopify-section-group-header-group').forEach((s) => {
      const p = getComputedStyle(s).position;
      if (p === 'sticky' || p === 'fixed') head = Math.max(head, s.getBoundingClientRect().height);
    });
    const tb = $('.mbtlwraper');
    const foot = tb && getComputedStyle(tb).display !== 'none' ? tb.getBoundingClientRect().height : 0;
    if (head) root.style.setProperty('--stl-head', Math.round(head) + 'px');
    root.style.setProperty('--stl-bottom-offset', Math.floor(foot) + 'px');
  }
  function chrome(root) {
    const run = () => placeChrome(root);
    run();
    window.addEventListener('resize', run);
    window.addEventListener('load', run);
  }

  /* ---------- bottom sheets (mobile) ---------- */
  function sheets(root) {
    const ovl = $('.m-ovl', root);
    let last = null;
    const open = (name) => {
      $$('[data-stl-sheet]', root).forEach((s) => s.classList.toggle('open', s.dataset.stlSheet === name));
      if (ovl) ovl.classList.toggle('on', !!name);
      document.documentElement.style.overflow = name ? 'hidden' : '';
      if (name) { last = document.activeElement; const b = $(`[data-stl-sheet="${name}"] button`, root); if (b) b.focus({ preventScroll: true }); }
      else if (last && last.focus) { last.focus({ preventScroll: true }); last = null; }
    };
    root.addEventListener('click', (e) => {
      const o = e.target.closest('[data-stl-sheet-open]');
      if (o) { open(o.dataset.stlSheetOpen); return; }
      if (e.target.closest('[data-stl-sheet-close]')) open(null);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && $('.m-sheet.open', root)) { e.stopImmediatePropagation(); open(null); }
    });
    MOBILE.addEventListener('change', () => { if (!isMobile()) open(null); });
    return open;
  }

  /* ---------- money (Shopify amounts are in cents) ---------- */
  function formatMoney(cents, fmt) {
    const n = (Number(cents) || 0) / 100;
    const f = (d, ts, ds) => { const [a, b] = n.toFixed(d).split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (b ? ds + b : ''); };
    const map = {
      amount: f(2, ',', '.'), amount_no_decimals: f(0, ',', '.'),
      amount_with_comma_separator: f(2, '.', ','), amount_no_decimals_with_comma_separator: f(0, '.', ','),
      amount_with_space_separator: f(2, ' ', ','), amount_no_decimals_with_space_separator: f(0, ' ', ','),
      amount_with_apostrophe_separator: f(2, "'", '.'), amount_with_period_and_space_separator: f(2, ' ', '.'),
    };
    return String(fmt || '{{amount_with_comma_separator}} DT').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => map[k] ?? map.amount);
  }

  /* ---------- saved looks (localStorage; never required — a blocked storage just saves nothing) ---------- */
  const SAVED_KEY = 'omes:stl:saved';
  const saved = {
    get() { try { return new Set(JSON.parse(localStorage.getItem(SAVED_KEY) || '[]')); } catch { return new Set(); } },
    toggle(h) {
      const s = this.get(); s.has(h) ? s.delete(h) : s.add(h);
      try { localStorage.setItem(SAVED_KEY, JSON.stringify([...s])); } catch { /* ignore */ }
      document.dispatchEvent(new CustomEvent('stl:saved', { detail: [...s] }));
    },
  };
  function paintSaved() {
    const s = saved.get();
    $$('[data-stl-save]').forEach((b) => {
      const on = s.has(b.dataset.stlSave);
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', String(on));
      const label = on ? b.dataset.labelOn : b.dataset.labelOff;
      if (!label) return;
      const t = b.querySelector('[data-label]');
      if (t) t.textContent = label; else b.setAttribute('aria-label', label);
    });
    $$('[data-stl-saved-count]').forEach((el) => { el.textContent = String(s.size); });
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-stl-save]');
    if (b) { e.preventDefault(); e.stopPropagation(); saved.toggle(b.dataset.stlSave); return; }
    // A card opens its look from anywhere on it, on the grid as in « Plus de looks ».
    const card = e.target.closest('[data-stl-card]');
    if (card && !e.target.closest('a, button')) location.href = card.dataset.href;
  });
  document.addEventListener('stl:saved', paintSaved);

  /* ---------- grid ---------- */
  const DEF = { gender: 'Tous', occasion: 'Toutes', brand: 'Toutes', curator: 'Tous', savedOnly: false };
  const QS = { gender: 'pour', occasion: 'occasion', brand: 'marque', curator: 'signe' };

  function initGrid(root) {
    const S = JSON.parse(root.dataset.strings || '{}');
    const st = { ...DEF };
    const q = new URLSearchParams(location.search);
    for (const k in QS) if (q.get(QS[k])) st[k] = q.get(QS[k]);
    st.savedOnly = q.get('enregistres') === '1';
    const cards = $$('[data-stl-card]', root);
    if (!cards.length) return;
    const counts = $$('[data-stl-count]', root);
    const empty = $('[data-stl-empty]', root);
    const fcount = $('[data-stl-fcount]', root);
    const fbtn = $('.m-fbtn', root);
    const see = $('[data-stl-see]', root);
    chrome(root);
    sheets(root);

    function apply() {
      const s = saved.get();
      let n = 0;
      cards.forEach((c) => {
        const ok = (st.gender === 'Tous' || c.dataset.gender === st.gender)
          && (st.occasion === 'Toutes' || c.dataset.occasion === st.occasion)
          && (st.brand === 'Toutes' || (c.dataset.brands || '').includes('|' + st.brand + '|'))
          && (st.curator === 'Tous' || c.dataset.curator === st.curator)
          && (!st.savedOnly || s.has(c.dataset.handle));
        c.hidden = !ok;
        if (ok) n++;
      });
      $$('[data-filter]', root).forEach((el) => {
        const k = el.dataset.filter;
        if (el.tagName === 'SELECT') { el.value = st[k]; return; }
        const on = k === 'savedOnly' ? st.savedOnly : el.dataset.value === st[k];
        el.classList.toggle('on', on);
        el.setAttribute(el.getAttribute('role') === 'switch' ? 'aria-checked' : 'aria-pressed', String(on));
      });
      const label = (n > 1 ? S.countOther : S.countOne || '{n}').replace('{n}', n);
      counts.forEach((c) => { c.textContent = label; });
      const fN = (st.occasion !== DEF.occasion) + (st.brand !== DEF.brand) + (st.curator !== DEF.curator) + (st.savedOnly ? 1 : 0);
      if (fcount) { fcount.textContent = String(fN); fcount.hidden = fN === 0; }
      if (fbtn) fbtn.classList.toggle('on', fN > 0);
      if (see) see.textContent = (n > 1 ? S.seeOther : S.seeOne || '{n}').replace('{n}', n);
      if (empty) empty.hidden = n > 0;
      const u = new URL(location.href);
      for (const k in QS) st[k] === DEF[k] ? u.searchParams.delete(QS[k]) : u.searchParams.set(QS[k], st[k]);
      st.savedOnly ? u.searchParams.set('enregistres', '1') : u.searchParams.delete('enregistres');
      history.replaceState(history.state, '', u);
    }

    root.addEventListener('click', (e) => {
      const f = e.target.closest('[data-filter]');
      if (f && f.tagName !== 'SELECT') {
        const k = f.dataset.filter;
        if (k === 'savedOnly') st.savedOnly = !st.savedOnly; else st[k] = f.dataset.value;
        apply(); return;
      }
      if (e.target.closest('[data-stl-reset]')) { Object.assign(st, DEF); apply(); }
    });
    root.addEventListener('change', (e) => {
      const el = e.target.closest('select[data-filter]');
      if (el) { st[el.dataset.filter] = el.value; apply(); }
    });
    document.addEventListener('stl:saved', apply);
    apply();
  }

  /* ---------- look detail ---------- */
  function initDetail(root) {
    const data = JSON.parse($('script[data-stl-look]', root).textContent);
    const S = data.strings;
    const KEY = 'omes:stl:look:' + data.handle;
    const unique = (list) => [...new Set(list.filter((x) => x != null))];
    const oneSize = (o) => o.sizeIndex < 0;
    const colorsOf = (o) => (o.colorIndex < 0 ? [] : unique(o.variants.map((v) => v.color)));
    const inColor = (o, color) => o.variants.filter((v) => o.colorIndex < 0 || color == null || v.color === color);
    const sizesOf = (o, color) => unique(inColor(o, color).map((v) => v.size));
    const firstColor = (o) => { if (o.colorIndex < 0) return null; const v = o.variants.find((x) => x.available) || o.variants[0]; return v ? v.color : null; };
    const variantFor = (o, size, color) => inColor(o, color).find((v) => v.available && (oneSize(o) || v.size === size)) || null;
    /* A size option with one value (« 40L - Small ») is chosen already: there is nothing to ask. */
    const loneSize = (o, color) => { if (oneSize(o)) return null; const sizes = sizesOf(o, color); return sizes.length === 1 && variantFor(o, sizes[0], color) ? sizes[0] : null; };
    const fresh = () => data.pieces.map((p) => { const color = firstColor(p.options[0]); return { opt: 0, size: loneSize(p.options[0], color), color, included: true, open: false }; });
    let slots = null;
    try { slots = JSON.parse(sessionStorage.getItem(KEY)); } catch { /* ignore */ }
    const valid = Array.isArray(slots) && slots.length === data.pieces.length && slots.every((s, i) => s && data.pieces[i].options[s.opt]);
    if (!valid) slots = fresh();
    slots.forEach((s, i) => { if (s.color === undefined) s.color = firstColor(data.pieces[i].options[s.opt]); });

    let active = null;
    let errs = [];
    const rowsEl = $('[data-stl-rows]', root);
    const totLabel = $('[data-stl-total-label]', root);
    const totEl = $('[data-stl-total]', root);
    const cta = $('[data-stl-add]', root);
    const msg = $('[data-stl-error]', root);
    const toast = $('[data-stl-toast]', root);
    const peek = $('[data-stl-peek]', root);
    const pbar = $('[data-stl-pbar]', root);
    chrome(root);
    const openSheet = sheets(root);
    const money = (c) => formatMoney(c, data.moneyFormat);
    const cur = (i) => data.pieces[i].options[slots[i].opt];
    /* The chosen variant's price once it is known, the product's lowest price until then. */
    const priceOf = (i) => { const o = cur(i); const v = variantFor(o, slots[i].size, slots[i].color); return v && (oneSize(o) || slots[i].size) ? v.price : o.price; };
    const imageOf = (i) => { const o = cur(i); if (o.colorIndex < 0) return o.image; const v = o.variants.find((x) => x.color === slots[i].color && x.image); return v ? v.image : o.image; };
    const ICON_CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l5 5 9-10"></path></svg>';

    function rowHtml(p, i) {
      const s = slots[i]; const o = cur(i); const err = errs.includes(i);
      const colors = colorsOf(o);
      const colorBtns = colors.length > 1 ? colors.map((c) => {
        const avail = o.variants.some((v) => v.color === c && v.available);
        return `<button type="button" class="sz cl${s.color === c ? ' on' : ''}" data-act="color" data-i="${i}" data-color="${esc(c)}" aria-pressed="${s.color === c}"${avail ? '' : ' disabled'}>${esc(c)}</button>`;
      }).join('') : '';
      const sizes = sizesOf(o, s.color).map((z) => {
        const avail = inColor(o, s.color).some((v) => v.size === z && v.available);
        return `<button type="button" class="sz${s.size === z ? ' on' : ''}" data-act="size" data-i="${i}" data-size="${esc(z)}" aria-pressed="${s.size === z}"${avail ? '' : ' disabled'}>${esc(z)}</button>`;
      }).join('');
      const alts = p.options.map((a, k) => (k === s.opt ? '' : `<button type="button" class="alt" data-act="pick" data-i="${i}" data-k="${k}"><span class="th"><img src="${esc(a.image)}" alt="" loading="lazy"></span><span class="mono rbrand">${esc(k === 0 ? S.originalTag : a.vendor)}</span><span class="an">${esc(a.title)}</span><span class="ap">${money(a.price)}</span></button>`)).join('');
      return `<div class="row${active === i ? ' on' : ''}${s.included ? '' : ' off'}${err ? ' err' : ''}" data-i="${i}">`
        + `<button type="button" class="ck${s.included ? ' on' : ''}" data-act="include" data-i="${i}" aria-pressed="${s.included}" aria-label="${esc(s.included ? S.excludeAria : S.includeAria)}">${ICON_CHECK}</button>`
        + `<span class="th"><img src="${esc(imageOf(i))}" alt="" loading="lazy">${p.hotspot ? `<em>${i + 1}</em>` : ''}</span>`
        + '<div class="rmain">'
        + `<div class="rtop"><span class="mono rbrand">${esc(o.vendor)}</span><span class="rprice">${money(priceOf(i))}</span></div>`
        + `<p class="rname"><a href="${esc(o.url)}">${esc(o.title)}</a>${s.opt ? `<span class="swp">${esc(S.swappedBadge)}</span>` : ''}</p>`
        + (colorBtns ? `<div class="sizes cols">${colorBtns}</div>` : '')
        + (oneSize(o) ? (colorBtns ? '' : `<p class="tu">${esc(S.oneSize)}</p>`) : `<div class="sizes">${sizes}</div>`)
        + (err ? `<p class="errt">${esc(S.sizeError)}</p>` : '')
        + (p.options.length > 1 ? `<button type="button" class="swap" data-act="toggle" data-i="${i}" aria-expanded="${s.open}">${esc(s.open ? S.swapClose : S.swapOpen)}</button>` : '')
        + (s.open ? `<div class="alts">${alts}</div>` : '')
        + '</div></div>';
    }

    function paintActive() {
      $$('.row', rowsEl).forEach((r) => r.classList.toggle('on', Number(r.dataset.i) === active));
      $$('[data-stl-dot]', root).forEach((d) => {
        const i = Number(d.dataset.i); const o = cur(i);
        d.classList.toggle('on', active === i);
        d.classList.toggle('off', !slots[i].included);
        d.setAttribute('aria-label', o.title);
        let tip = d.querySelector('.tip');
        if (active === i && !isMobile()) {
          if (!tip) { tip = document.createElement('span'); tip.className = 'tip'; d.appendChild(tip); }
          tip.innerHTML = `<b>${esc(o.title)}</b>${money(priceOf(i))}`;
        } else if (tip) tip.remove();
      });
      if (peek) {
        const on = active != null && isMobile();
        peek.classList.toggle('on', on);
        if (pbar) pbar.classList.toggle('hide', on);
        if (on) {
          const o = cur(active); const img = $('[data-stl-peek-img]', peek);
          img.src = imageOf(active); img.hidden = false;
          $('[data-stl-peek-brand]', peek).textContent = o.vendor;
          $('[data-stl-peek-name]', peek).textContent = `${active + 1} · ${o.title}`;
          $('[data-stl-peek-price]', peek).textContent = money(priceOf(active));
        }
      }
    }
    function scrollToRow(i) {
      const r = rowsEl.querySelector(`.row[data-i="${i}"]`);
      if (!r) return;
      const head = parseFloat(getComputedStyle(root).getPropertyValue('--stl-head')) || 72;
      window.scrollTo({ top: r.getBoundingClientRect().top + window.scrollY - head - 12, behavior: reduced() ? 'auto' : 'smooth' });
    }
    function openAlts(i) {
      const p = data.pieces[i]; const s = slots[i];
      $('[data-stl-alt-current]', root).textContent = S.altCurrent.replace('{name}', cur(i).title);
      $('[data-stl-alts]', root).innerHTML = p.options.map((a, k) => (k === s.opt ? '' : `<button type="button" class="m-arow" data-act="pick" data-i="${i}" data-k="${k}"><span class="m-ath"><img src="${esc(a.image)}" alt="" loading="lazy"></span><span class="m-ainfo"><span class="mono">${esc(k === 0 ? S.originalTag : a.vendor)}</span><b>${esc(a.title)}</b><span>${money(a.price)}</span></span><span class="m-choose">${esc(S.choose)}</span></button>`)).join('');
      setActive(i);
      openSheet('alts');
    }
    function setActive(i) { if (i === active) return; active = i; paintActive(); }

    function render() {
      try { sessionStorage.setItem(KEY, JSON.stringify(slots)); } catch { /* ignore */ }
      rowsEl.innerHTML = data.pieces.map(rowHtml).join('');
      const inc = slots.map((_, i) => i).filter((i) => slots[i].included);
      const tOne = isMobile() ? S.mobileTotalOne : S.totalOne; const tOther = isMobile() ? S.mobileTotalOther : S.totalOther;
      totLabel.textContent = (inc.length > 1 ? tOther : tOne).replace('{n}', inc.length);
      totEl.textContent = money(inc.reduce((a, i) => a + priceOf(i), 0));
      cta.disabled = inc.length === 0;
      msg.hidden = errs.length === 0;
      if (errs.length) msg.textContent = S.errorSummary.replace('{names}', errs.map((i) => cur(i).title).join(', '));
      paintActive();
    }

    function showToast(text) {
      if (!toast) return;
      $('[data-stl-toast-text]', toast).textContent = text;
      toast.hidden = false;
      clearTimeout(showToast.t);
      showToast.t = setTimeout(() => { toast.hidden = true; }, 3600);
    }

    async function addLook() {
      const inc = slots.map((_, i) => i).filter((i) => slots[i].included);
      errs = inc.filter((i) => !oneSize(cur(i)) && !slots[i].size);
      if (errs.length) { render(); if (isMobile()) scrollToRow(errs[0]); return; }
      const items = inc.map((i) => { const v = variantFor(cur(i), slots[i].size, slots[i].color); return v && { id: v.id, quantity: 1, properties: { _look: data.handle } }; });
      const missing = inc.filter((_, k) => !items[k]);
      if (missing.length) { errs = missing; render(); return; }
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = location.pathname;
      }
      if (cart && typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      cta.disabled = true;
      try {
        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        const r = await fetch(addUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          body: JSON.stringify(body),
        });
        const j = await r.json().catch(() => ({}));
        if (!r.ok || j.status) throw new Error(j.description || j.message || S.addError);
        const drawn = !!(cart && typeof cart.renderContents === 'function' && j.sections);
        if (drawn) {
          // A drawer still marked empty traps focus on its empty state, which the new contents replaced.
          cart.classList.remove('is-empty');
          cart.renderContents(j);
        }
        // Every place that changes cart lines lets OMES Bundles put its codes back (avone6_theme/AGENTS.md).
        if (window.OmesBundles) await window.OmesBundles.reconcile().catch(() => null);
        showToast((items.length > 1 ? S.toastOther : S.toastOne).replace('{title}', data.title).replace('{n}', items.length));
      } catch (err) {
        msg.hidden = false; msg.textContent = String(err && err.message ? err.message : S.addError);
      } finally { cta.disabled = false; }
    }

    root.addEventListener('click', (e) => {
      const d = e.target.closest('[data-stl-dot]');
      if (d) { const i = Number(d.dataset.i); setActive(active === i ? null : i); return; }
      if (e.target.closest('[data-stl-peek-go]')) { if (active != null) scrollToRow(active); return; }
      if (e.target.closest('[data-stl-peek-close]')) { setActive(null); return; }
      const b = e.target.closest('[data-act]');
      if (!b) return;
      const i = Number(b.dataset.i); const s = slots[i];
      if (b.dataset.act === 'size') { s.size = b.dataset.size; active = i; }
      else if (b.dataset.act === 'color') {
        s.color = b.dataset.color; active = i;
        if (s.size != null && !inColor(cur(i), s.color).some((v) => v.size === s.size && v.available)) s.size = null;
        if (s.size == null) s.size = loneSize(cur(i), s.color);
      }
      else if (b.dataset.act === 'include') s.included = !s.included;
      else if (b.dataset.act === 'toggle') { if (isMobile()) { openAlts(i); return; } s.open = !s.open; }
      else if (b.dataset.act === 'pick') { s.opt = Number(b.dataset.k); s.color = firstColor(cur(i)); s.size = loneSize(cur(i), s.color); s.open = false; openSheet(null); }
      errs = [];
      render();
    });
    rowsEl.addEventListener('mouseover', (e) => { if (isMobile()) return; const r = e.target.closest('.row'); if (r) setActive(Number(r.dataset.i)); });
    rowsEl.addEventListener('focusin', (e) => { const r = e.target.closest('.row'); if (r) setActive(Number(r.dataset.i)); });
    cta.addEventListener('click', addLook);
    rowsEl.addEventListener('click', (e) => { if (isMobile() && e.target.closest('.th')) { const r = e.target.closest('.row'); if (r) setActive(Number(r.dataset.i)); } });
    const photo = $('.photo', root);
    if (photo) {
      let x0 = 0; let y0 = 0;
      photo.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      photo.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - x0; const dy = e.changedTouches[0].clientY - y0;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) { const u = dx < 0 ? data.nextUrl : data.prevUrl; if (u && u !== location.pathname) location.href = u; }
      }, { passive: true });
    }
    MOBILE.addEventListener('change', render);
    document.addEventListener('keydown', (e) => {
      if (/INPUT|SELECT|TEXTAREA/.test((e.target && e.target.tagName) || '')) return;
      // A sheet, the cart drawer or any theme overlay (they lock the page with html.of-hidden) keeps its keys.
      if ($('.m-sheet.open', root) || document.querySelector('cart-drawer.active') || document.documentElement.classList.contains('of-hidden')) return;
      if (e.key === 'ArrowRight' && data.nextUrl && data.nextUrl !== location.pathname) location.href = data.nextUrl;
      else if (e.key === 'ArrowLeft' && data.prevUrl && data.prevUrl !== location.pathname) location.href = data.prevUrl;
      else if (e.key === 'Escape' && data.gridUrl) location.href = data.gridUrl;
    });
    render();
  }

  function boot() {
    $$('[data-stl-grid]').forEach(initGrid);
    $$('[data-stl-detail]').forEach(initDetail);
    paintSaved();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot); // theme editor
  window.OmesShopTheLook = { formatMoney, saved, reduced };
})();
